import { useLocalStorage } from "usehooks-ts"
import { useAuth0 } from "@auth0/auth0-react"
import { useEffect } from "react"

export default function useOrgId() {
  const [orgId] = useLocalStorage<string | undefined>("orgId", undefined)
  const { user } = useAuth0()
  // The reason to use this is that before the session is loaded, i you use the session the orgId will be undefined
  // When the state is loaded, then all the endpoints will be enabled, but the orgId will be undefined for the first render
  // which will case allot of requests to be made with the wrong orgId
  // which will be cancelled when the orgId is set and therefore slow down the backend while
  // these requests are being processed
  // This is a way to prevent that from happening
  return user?.org_id ?? orgId
}

export function useSyncOrgId() {
  const { user, isAuthenticated } = useAuth0()
  const [orgId, setOrgId] = useLocalStorage<string | undefined>("orgId", undefined)

  useEffect(() => {
    if (isAuthenticated && user?.org_id && orgId !== user.org_id) {
      console.info(
        "Syncing orgId",
        "from",
        orgId,
        "to",
        user.org_id,
        "because of ",
        isAuthenticated,
      )
      setOrgId(user.org_id)
    }
  }, [isAuthenticated, user, orgId, setOrgId])
}
